var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconIcLanguage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "6A9BCE8D-BD60-4AC3-B144-3D01846BEF14") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A8E2FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A0CDFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0084E4",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#004CC4",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Profile",
    transform: "translate(-1060.000000, -716.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9-Copy-8",
    transform: "translate(1048.000000, 704.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "translate",
    transform: "translate(12.000000, 12.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.8451538,8.15887453 L10.3138733,8.15887453 C9.12567141,8.15887453 8.15902711,9.12551879 8.15902711,10.3137207 L8.15902711,14.4055176 L6.20773316,15.7992554 C6.05377195,15.9091187 5.96237184,16.0867309 5.96237184,16.2759399 C5.96237184,16.4653015 6.05377195,16.6429138 6.20773316,16.7527771 L8.18252563,18.1632996 C8.33679199,19.2012024 9.23385621,20 10.3138733,20 L17.8451538,20 C19.0333557,20 20,19.0333557 20,17.8450012 L20,10.3137207 C20,9.12551879 19.0333557,8.15887453 17.8451538,8.15887453 Z M15.3128052,16.3922119 C15.1747131,16.3922119 15.0680542,16.3484192 15.0367737,16.2290955 L14.7981262,15.3942871 L13.3607483,15.3942871 L13.122406,16.2290955 C13.0909729,16.3484192 12.984314,16.3922119 12.8462219,16.3922119 C12.6264954,16.3922119 12.331543,16.2542725 12.331543,16.0534668 C12.331543,16.040802 12.3377991,16.0157776 12.3440552,15.9906006 L13.5554504,12.0428467 C13.611908,11.8545532 13.8441467,11.76651 14.0763855,11.76651 C14.3148804,11.76651 14.5471191,11.8545532 14.6035766,12.0428467 L15.8149719,15.9906006 C15.821228,16.0157776 15.8274841,16.0345459 15.8274841,16.0534668 C15.8274841,16.2478637 15.5325317,16.3922119 15.3128052,16.3922119 L15.3128052,16.3922119 Z",
    id: "Shape",
    fill: "url(#linearGradient-1)"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#148BE9",
    opacity: 0.299999982,
    points: "13.5302734 14.7540283 14.6224976 14.7540283 14.0762329 12.827301"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.98715211,10.3137207 C6.98715211,9.52697754 7.26226805,8.80371094 7.72048949,8.23349 C7.05200195,8.23349 6.43173219,8.02429199 5.92041016,7.6689148 C5.40908813,8.02444457 4.78881836,8.23349 4.1201782,8.23349 C3.9378357,8.23349 3.78982543,8.08547973 3.78982543,7.90298461 C3.78982543,7.72048949 3.9378357,7.57263184 4.1201782,7.57263184 C4.58847047,7.57263184 5.02670289,7.44293211 5.40191648,7.21832273 C4.94934082,6.72988891 4.6484375,6.09924316 4.57565309,5.40130617 L4.12033082,5.40130617 C3.9378357,5.40130617 3.78982543,5.25344848 3.78982543,5.07095336 C3.78982543,4.88845824 3.9378357,4.74044801 4.12033082,4.74044801 L5.59020996,4.74044801 L5.59020996,3.93814086 C5.59020996,3.75549316 5.73806762,3.60763551 5.92056273,3.60763551 C6.10305785,3.60763551 6.25091555,3.75549316 6.25091555,3.93814086 L6.25091555,4.74044801 L7.72079469,4.74044801 C7.9032898,4.74044801 8.05130004,4.88845824 8.05130004,5.07095336 C8.05130004,5.25344848 7.9032898,5.40130617 7.72079469,5.40130617 L7.26547242,5.40130617 C7.19268797,6.09924316 6.89178469,6.72988891 6.43920898,7.21832273 C6.81427,7.4432373 7.25265504,7.57263184 7.72079469,7.57263184 C7.89520266,7.57263184 8.03771973,7.70782469 8.05007934,7.8791809 C8.64440918,7.32620238 9.44015504,6.98699953 10.3140259,6.98699953 L11.8411255,6.98699953 L11.8411255,5.59448242 L13.7924195,4.20074461 C13.946228,4.09088133 14.0376282,3.91326906 14.0376282,3.72406008 C14.0376282,3.53469848 13.946228,3.35708617 13.7924195,3.24722289 L11.817627,1.83670043 C11.663208,0.798797617 10.7661438,0 9.68612672,0 L2.15499879,0 C0.966644297,0 0,0.966644297 0,2.15484617 L0,9.6862793 C0,10.8744812 0.966644297,11.8411255 2.15499879,11.8411255 L6.98715211,11.8411255 L6.98715211,10.3137207 Z",
    id: "Path",
    fill: "url(#linearGradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.92041016,6.80541992 C6.28204344,6.43020629 6.52755738,5.94299316 6.59942625,5.40145875 L5.24154664,5.40145875 C5.31341555,5.94299316 5.55908203,6.43020629 5.92041016,6.80541992 Z",
    id: "Path",
    fill: "#148BE9"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconIcLanguage);
export default __webpack_public_path__ + "static/media/icon-ic-language.5489ae14a51a9e334dcca17651b913b2.svg";
export { ForwardRef as ReactComponent };